import { Checkbox } from 'src/components/ui/checkbox';
import { Control, Controller, UseFormTrigger } from 'react-hook-form';
import { clsx } from 'clsx';
import type {
  WorkflowActionPath,
  WorkflowFormValues,
} from 'src/pages/ConfigurationPage/WorkflowsTab/workflowFormValues';

export const WorkflowActionFieldPhone = ({
  namePrefix = 'action.0',
  control,
  trigger = () => Promise.resolve(true),
}: {
  namePrefix?: WorkflowActionPath;
  control: Control<WorkflowFormValues>;
  trigger?: UseFormTrigger<WorkflowFormValues>;
}) => {
  const idPrefix = namePrefix.split('.')[1];

  return (
    <div className="flex flex-row items-center space-x-2.5">
      <Controller
        control={control}
        name={`${namePrefix}.action_fields_phone_number`}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          return (
            <div className={'flex flex-row items-center space-x-2.5'}>
              <label
                htmlFor={`${idPrefix}action_fields_phone_number`}
                className={clsx(
                  'flex flex-row items-center gap-2.5 font-medium text-sm text-ebony_opacity_50 cursor-pointer leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
                  error?.message && 'text-error',
                )}
              >
                <Checkbox
                  id={`${idPrefix}action_fields_phone_number`}
                  checked={value}
                  onCheckedChange={(val) => {
                    onChange(val);
                    trigger([
                      `${namePrefix}.action_fields_phone_number`,
                      `${namePrefix}.action_fields_name`,
                      `${namePrefix}.action_fields_email`,
                      `${namePrefix}.action_fields_custom`,
                      `${namePrefix}.action_data_collection`,
                    ]);
                  }}
                  className={clsx(error?.message && 'border-error')}
                />
                Phone number
              </label>
            </div>
          );
        }}
      />
    </div>
  );
};
